const dropdown = () => {
  const dropdowns = document.querySelectorAll<HTMLElement>( '[data-v8-dropdown]' )
  const dropdownContainers = document.querySelectorAll<HTMLElement>( '[data-v8-dropdown-content]' )
  dropdownContainers.forEach( container => container.hidden = true )
  dropdowns.forEach( dropdown => {
    dropdown.ariaExpanded = 'false'
    const id = dropdown.dataset.v8Dropdown
    const chevron = dropdown.querySelector<HTMLElement>( '.chevron' )
    const dropdownContainer = document.querySelector<HTMLElement>( `[data-v8-dropdown-content="${id}"]` )
    if ( dropdownContainer ) {
      dropdown.addEventListener( 'click', () => {
        dropdownContainer.hidden = ! dropdownContainer.hidden
        dropdown.ariaExpanded = dropdown.ariaExpanded === 'false' ? 'true' : 'false'
        dropdownContainer.classList.toggle( 'hidden' )
        if ( chevron ) chevron.classList.toggle( 'rotate-180' )
      } )
    }
    // const link = dropdown.querySelector( 'a' )
    // const submenu = dropdown.querySelector( '.hidden' )
    // const button = dropdown.querySelector( 'button' )
    // dropdown.addEventListener( 'mouseover', () => {
    //   dropdown.classList.add( 'open' )
    //   if ( link ) link.setAttribute( 'aria-expanded', 'true' )
    //   if ( button ) button.setAttribute( 'aria-expanded', 'true' )
    //   if ( submenu ) submenu.classList.remove( 'hidden' )
    // } )
    // dropdown.addEventListener( 'mouseout', () => {
    //   dropdown.classList.remove( 'open' )
    //   if ( link ) link.setAttribute( 'aria-expanded', 'false' )
    //   if ( button ) button.setAttribute( 'aria-expanded', 'false' )
    //   if ( submenu ) submenu.classList.add( 'hidden' )
    // } )
    // if ( button ) {
    //   button.addEventListener( 'click', () => {
    //     dropdown.classList.toggle( 'open' )
    //     if ( submenu ) submenu.classList.toggle( 'hidden' )
    //   } )
    // }
  } )
}

export default dropdown